import styled from 'styled-components';

export const InvoiceAnnotation = styled.h3`
  font-size: 1em;
  text-transform: uppercase;
  letter-spacing: 0.084em;
  font-weight: normal;
`;
